import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiResult } from '../../shared/models/api-result.model';
import { ReasonType } from '../models/reason.model';

@Injectable({
  providedIn: 'root',
})
export class ReasonService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getDropdown(type: ReasonType) {
    return this.http.get<ApiResult>(
      `${this.apiBaseUrl}/api/v1/reasons/dropdown`,
      {
        params: new HttpParams().set('type', type),
      },
    );
  }
}
